let lockReconnect = false;
let wsUrl = `ws://${window.location.host}/api/posclient/order/socketInfo`;
let socket = null;
let testCode = null;

let heartCheck = {
  timeout: 25000,
  checkTimer: null,
  pingTimeout: null,
  lastMessageTime: Date.now(),

  reset: function (dispatch) {
    this.lastMessageTime = Date.now();

    this.clearTimers();
    this.start(dispatch);
    return this;
  },

  clearTimers: function () {
    if (this.checkTimer) {
      console.log('清除檢查計時器', this.checkTimer);
      clearInterval(this.checkTimer);
      this.checkTimer = null;
    }
    if (this.pingTimeout) {
      console.log('清除 ping 超時計時器', this.pingTimeout);
      clearTimeout(this.pingTimeout);
      this.pingTimeout = null;
    }
  },

  start: function (dispatch) {
    const self = this;

    // 使用箭頭函數來保持 this 的指向
    const check = () => {
      const currentTime = Date.now();
      const idleTime = currentTime - self.lastMessageTime;

      if (idleTime >= self.timeout) {
        if (socket && socket.readyState === WebSocket.OPEN) {
          console.log('閑置時間超過25秒，發送心跳檢查');
          socket.send(`ping ${testCode}`);

          // 設置 5 秒超時檢查
          self.pingTimeout = setTimeout(() => {
            console.log('Ping 超時未收到回應，重新連線');
            self.clearTimers(); // 清除所有計時器
            socket.close(); // 關閉當前連接，觸發重連
          }, 5000);
        }
      }
    };

    // 設置新的計時器
    this.checkTimer = setInterval(check, 1000);
    console.log('設置新計時器', this.checkTimer);
  },
};

export default {
  namespaced: true,
  state: {
    info: null,
    orderList: null,
    data: null,
    memberPhoneDialogState: null,
    memberPhone: null,
  },

  getters: {
    getPushInfo: (state) => state.info,
    getOrderList: (state) => state.orderList,
    getData: (state) => state.data,
    getMemberPhoneDialogState: (state) => state.memberPhoneDialogState,
    getMemberPhone: (state) => state.memberPhone,
  },

  mutations: {
    SET_INFO(state, data) {
      state.info = data;
    },
    SET_ORDER_LIST(state, data) {
      state.orderList = data;
    },
    SET_ACTION(state, { action, data }) {
      state.data = data;
    },
    SET_MEMBER_PHONE_DIALOG_STATE(state, dialogState) {
      state.memberPhoneDialogState = dialogState;
    },
    SET_MEMBER_PHONE(state, phone) {
      state.memberPhone = phone;
    },
    RESET(state) {
      state.info = null;
      state.action = null;
      state.data = null;
    },
  },

  actions: {
    createWebSocket({ dispatch }) {
      try {
        if ('WebSocket' in window) {
          socket = new WebSocket(wsUrl);
          testCode = Math.random().toString(36).substring(7);
        }
        dispatch('connectSocket');
      } catch (e) {
        dispatch('reconnect');
        console.log(e);
      }
    },
    connectSocket({ commit, dispatch }) {
      socket.onopen = function () {
        dispatch(
          'order/doPushInfoForGuest',
          {
            type: 'ping',
            data: testCode,
          },
          { root: true }
        );
        heartCheck.reset(dispatch);
      };

      socket.onmessage = function (event) {
        try {
          const message = JSON.parse(event.data);
          const { action, data: payload } = message;
          console.log('message', !!message);

          if (message) {
            heartCheck.reset(dispatch);
            // socket.send(`pine${testCode}`);
          }
          if (action === 'ping' && payload === testCode) {
            console.log('收到正確的 ping 回應，重置心跳計時器');
            if (heartCheck.pingTimeout) {
              clearTimeout(heartCheck.pingTimeout);
              heartCheck.pingTimeout = null;
            }
            heartCheck.lastMessageTime = Date.now();
            return;
          }

          switch (action) {
            case 'update_order':
              commit('SET_ORDER_LIST', payload);
              sessionStorage.setItem('info', event.data);
              break;
            case 'check_member_phone':
              console.log('SET_MEMBER_PHONE_DIALOG_STATE', payload);
              commit('SET_MEMBER_PHONE_DIALOG_STATE', !!payload?.dialogState);
              sessionStorage.setItem('memberDialogState', payload.dialogState);
              if (payload?.dialogState) {
                commit('SET_MEMBER_PHONE', payload.memberPhone);
                sessionStorage.setItem('memberPhone', JSON.stringify(payload.memberPhone));
              }
              break;
            default:
              break;
          }

          heartCheck.lastMessageTime = Date.now();
        } catch (e) {
          console.log('訊息處理錯誤，關閉連接', e);
          socket.close();
          return;
        }
      };

      socket.onerror = function (err) {
        console.log('error', err);
        dispatch('reconnect');
      };
      socket.onclose = function (e) {
        console.log('close', e);
        dispatch('reconnect');
      };
    },
    reconnect({ dispatch }) {
      if (lockReconnect) return;
      lockReconnect = true;
      setTimeout(function () {
        //没连接上会一直重连，设置延迟避免请求过多
        dispatch('createWebSocket');
        lockReconnect = false;
      }, 2000);
    },
  },
};
